module.exports = __webpack_public_path__ + "80a54d2126b08dfab425c86f89283ec5.svg";